import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { useTheme, alpha } from "@mui/material/styles";
import { jwtDecode } from "jwt-decode";
import { useTranslation } from "react-i18next";
import Novedades from "../Novedades/Novedades";
import DrawerInstrucciones from "../Instrucciones/DrawerInstrucciones";
import esFlag from "../../img/flags/es.svg";
import enFlag from "../../img/flags/gb.svg";
import chFlag from "../../img/flags/ch.svg";
import dkFlag from "../../img/flags/dk.svg";
import nlFlag from "../../img/flags/nl.svg";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Drawer from "@mui/material/Drawer";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import { Divider, Menu, MenuItem, Stack } from "@mui/material";
import { Badge } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import ViewKanbanOutlinedIcon from "@mui/icons-material/ViewKanbanOutlined";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import ContactMailOutlinedIcon from "@mui/icons-material/ContactMailOutlined";
import EuroIcon from "@mui/icons-material/Euro";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import WaterfallChartOutlinedIcon from "@mui/icons-material/WaterfallChartOutlined";
import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import RoundaboutRightOutlinedIcon from "@mui/icons-material/RoundaboutRightOutlined";
import AlignHorizontalLeftOutlinedIcon from "@mui/icons-material/AlignHorizontalLeftOutlined";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import DrawOutlinedIcon from "@mui/icons-material/DrawOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import VideoCameraFrontOutlinedIcon from "@mui/icons-material/VideoCameraFrontOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FactoryOutlined from "@mui/icons-material/FactoryOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import AssuredWorkloadOutlinedIcon from "@mui/icons-material/AssuredWorkloadOutlined";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import DryCleaningOutlinedIcon from "@mui/icons-material/DryCleaningOutlined";
import JoinLeftOutlinedIcon from "@mui/icons-material/JoinLeftOutlined";
import JoinRightOutlinedIcon from "@mui/icons-material/JoinRightOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import SportsCricketOutlinedIcon from "@mui/icons-material/SportsCricketOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ImportExportOutlinedIcon from "@mui/icons-material/ImportExportOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import { makeStyles } from "@mui/styles";
import { ColorModeContext } from "../../constants/Theme1Provider";
import { SidebarContext } from "./SidebarProvider";
import {
  SIDEBAR_EXPANDED_WIDTH,
  SIDEBAR_MOBILE_WIDTH,
  SIDEBAR_RAIL_WIDTH,
  SidebarSectionHeader,
  sidebarRailNavSx,
} from "./SidebarRail";
import { getUserById } from "../../api/User/userApi";
import { mapUserToPermissionState } from "../../utils/userPermissionsUtils";
import {
  canAccessNmlSuzhou,
  canAccessNmlBoard,
} from "../../utils/nmlSuzhouCatalog";
import { TareasVistasApi } from "../../api/TareasVistas/TareasVistasApi";
import ChecklistRtlOutlinedIcon from "@mui/icons-material/ChecklistRtlOutlined";
import BubbleChartOutlinedIcon from "@mui/icons-material/BubbleChartOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ViewWeekOutlinedIcon from "@mui/icons-material/ViewWeekOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import LeaderboardOutlinedIcon from "@mui/icons-material/LeaderboardOutlined";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import Matrix5 from "../../img/logos/Matrix5.png";
import Matrix6 from "../../img/logos/Matrix6.png";
import { socket } from "../../socket";
import { getNotasNuevas } from "../../api/CriticalPath/criticalPathNotasApi";
import { usePendingTimeTrackingCount } from "../../hooks/usePendingTimeTrackingCount";

const LANGUAGE_FLAGS = [
  { code: "es", img: esFlag, alt: "Español" },
  { code: "en", img: enFlag, alt: "English" },
  { code: "ch", img: chFlag, alt: "中文" },
  { code: "dk", img: dkFlag, alt: "Dansk" },
  { code: "nl", img: nlFlag, alt: "Nederlands" },
];

const useStyles = makeStyles((theme) => ({
  logo: {
    width: "100%",
    maxWidth: "60px",
    margin: "20px 0px 20px 15px",
    display: "block",
  },
  logoutButton: {
    width: "100%",
    justifyContent: "flex-start",
    color: theme.palette.text.secondary,
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    margin: theme.spacing(0.5, 0.75),
    transition: "background-color 0.2s ease, color 0.2s ease",
    "&:hover": {
      backgroundColor: alpha(theme.palette.error.main, 0.08),
      color: theme.palette.error.main,
    },
  },
  cabsidebar: {
    "& .MuiTypography-root": {
      fontWeight: 700,
      color: theme.palette.text.primary,
      letterSpacing: 0.25,
    },
    "&.MuiListItemButton-root": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.common.white, 0.04)
          : alpha(theme.palette.primary.main, 0.06),
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: Number(theme.shape.borderRadius) * 2,
      margin: theme.spacing(0.5, 0.75),
      transition: "background-color 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        backgroundColor:
          theme.palette.mode === "dark"
            ? alpha(theme.palette.common.white, 0.08)
            : alpha(theme.palette.primary.main, 0.1),
        boxShadow: `0 1px 8px ${alpha(theme.palette.common.black, 0.06)}`,
      },
    },
  },
  cabsidebar1: {
    "&.MuiList-root": {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  cabsidebar2: {
    "& .MuiTypography-root": {
      fontWeight: 800,
      color: theme.palette.text.primary,
      letterSpacing: 0.35,
    },
    "&.MuiListItemButton-root": {
      background: `linear-gradient(135deg, ${alpha("#00bcd4", 0.16)} 0%, ${alpha("#673ab7", 0.14)} 100%)`,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: Number(theme.shape.borderRadius) * 2,
      margin: theme.spacing(0.5, 0.75),
      transition: "background 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        background: `linear-gradient(135deg, ${alpha("#00bcd4", 0.26)} 0%, ${alpha("#673ab7", 0.2)} 100%)`,
        boxShadow: `0 0 0 1px ${alpha(theme.palette.primary.main, 0.25)}`,
      },
    },
  },
  iconCRM: { color: theme.palette.primary.main },
  iconPLM: { color: theme.palette.text.quinto || "#FFAC7E" },
  iconAI: {
    color: theme.palette.mode === "dark" ? "#7ec8ff" : "#0288d1",
    transition: "color 0.2s ease, filter 0.2s ease",
    "&:hover": {
      color: theme.palette.mode === "dark" ? "#b3e0ff" : "#01579b",
      filter: "brightness(1.08)",
    },
  },
  iconMANUFACTURING: { color: "#b388ff" },
  iconADMIN: { color: theme.palette.secondary.main },
  iconCASH: { color: "#69f0ae" },
  iconNML: { color: "#26a69a" },
  iconREPORT: { color: theme.palette.mode === "dark" ? "#ff8a80" : "#e57373" },
  iconQr: { color: theme.palette.error.main },
  iconLOGOUT: { color: theme.palette.error.light },
  iconPAYMENT: { color: "#69f0ae" },
}));

const Sidebar = () => {
  const {
    isMinimized,
    toggleSidebar,
    sidebarAnchor,
    toggleAnchor,
    isMobile,
    mobileOpen,
    setMobileOpen,
    toggleMobileDrawer,
  } = useContext(SidebarContext);
  const useOverlay = isMobile || isMinimized;
  const showRail = false;
  const drawerWidth = useOverlay
    ? isMobile
      ? SIDEBAR_MOBILE_WIDTH
      : SIDEBAR_EXPANDED_WIDTH
    : SIDEBAR_EXPANDED_WIDTH;
  /*  const [anchor, setAnchor] = useState("left"); */ // "left" o "right"
  const classes = useStyles();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const colorMode = useContext(ColorModeContext);
  const theme = useTheme();
  const getNavLinkStyle = useCallback(
    ({ isActive }) => ({
      backgroundColor: isActive
        ? alpha(
            theme.palette.primary.main,
            theme.palette.mode === "dark" ? 0.24 : 0.12,
          )
        : "transparent",
      color: isActive ? theme.palette.primary.main : "inherit",
      borderLeft: `3px solid ${
        isActive ? theme.palette.primary.main : "transparent"
      }`,
      borderRadius: 10,
    }),
    [theme],
  );
  const [userPermissions, setUserPermissions] = useState({});
  // 🔴 Badge para nuevos movimientos
  const [movimientosNuevos, setMovimientosNuevos] = useState(0);
  // ---- auth / permisos  ----
  const token = localStorage.getItem("token");
  let userId = null;
  let abreviatura = null;
  let hasValidToken = false;
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      const isExpired = decodedToken.exp && decodedToken.exp < currentTime;
      userId = decodedToken.userId; // o el campo que uses
      abreviatura = decodedToken.abreviatura;
      if (isExpired || !userId) {
        localStorage.removeItem("token");
      } else {
        hasValidToken = true;
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      localStorage.removeItem("token");
    }
  }
  const isAuthScreen = pathname === "/login" || pathname === "/post-login";
  const isLoggedIn = hasValidToken && !isAuthScreen;
  // 🧠 Recuperar el estado guardado al montar
  useEffect(() => {
    const savedTheme = localStorage.getItem("themeMode");
    const savedAnchor = localStorage.getItem("sidebarAnchor");
    const savedMinimized = localStorage.getItem("isSidebarMinimized");
    if (savedTheme && savedTheme !== theme.palette.mode) {
      colorMode.setMode(savedTheme);
    }
    // 🔒 validamos que sea left o right
    if (
      savedAnchor &&
      ["left", "right"].includes(savedAnchor) &&
      savedAnchor !== sidebarAnchor
    ) {
      toggleAnchor(savedAnchor);
    }
    if (savedMinimized === "true" && !isMinimized && !isMobile) {
      toggleSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- restore sidebar prefs once on mount
  }, []);
  // 💾 Guardar los cambios cada vez que se modifican
  useEffect(() => {
    localStorage.setItem("themeMode", theme.palette.mode);
  }, [theme.palette.mode]);
  useEffect(() => {
    if (["left", "right"].includes(sidebarAnchor)) {
      localStorage.setItem("sidebarAnchor", sidebarAnchor);
    }
  }, [sidebarAnchor]);
  useEffect(() => {
    localStorage.setItem("isSidebarMinimized", isMinimized);
  }, [isMinimized]);

  useEffect(() => {
    if (isMobile) setMobileOpen(false);
  }, [pathname, isMobile, setMobileOpen]);

  const drawerContentRef = useRef(null);

  useEffect(() => {
    if (!mobileOpen) return;

    const timer = setTimeout(() => {
      const container = drawerContentRef.current;
      if (!container) return;
      const activeItem = container.querySelector('[aria-current="page"]');
      activeItem?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 150);

    return () => clearTimeout(timer);
  }, [mobileOpen, pathname]);

  useEffect(() => {
    const fetchPermissions = async () => {
      if (userId) {
        try {
          const user = await getUserById(userId);
          setUserPermissions(mapUserToPermissionState(user));
        } catch (err) {
          console.error("Error fetching user permissions", err);
        }
      } else {
        setUserPermissions({});
      }
    };
    fetchPermissions();

    const onFocus = () => fetchPermissions();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [userId]);
  const handleLogout = () => {
    localStorage.removeItem("token");
    setUserPermissions({});
    navigate("/login");
  };
  // escuchas el evento global "movimiento-registrado":
  useEffect(() => {
    const handleNuevoMovimiento = (movimiento) => {
      setMovimientosNuevos((prev) => prev + 1);
      // 🔊 Dispara evento global
      window.dispatchEvent(
        new CustomEvent("nuevo-movimiento", { detail: movimiento }),
      );
      localStorage.setItem("muestrasUbicacionNeedsRefresh", "true");
    };
    socket.on("movimiento-registrado", handleNuevoMovimiento);
    return () => socket.off("movimiento-registrado", handleNuevoMovimiento);
  }, []);
  // mantener el contador en localStorage "movimiento-registrado"
  useEffect(() => {
    const saved = localStorage.getItem("movimientosNuevos");
    if (saved) setMovimientosNuevos(Number(saved));
  }, []);
  useEffect(() => {
    localStorage.setItem("movimientosNuevos", movimientosNuevos);
  }, [movimientosNuevos]);
  // ---- estados de colapso ----
  const [openDASHBOARD, setOpenDASHBOARD] = useState(true);
  const [openCRM, setOpenCRM] = useState(true);
  const [openPNL, setOpenPNL] = useState(true);
  const [openRESOURCES, setOpenRESOURCES] = useState(true);
  const [openTRACKING, setOpenTRACKING] = useState(true);
  const [openVENTAS, setOpenVENTAS] = useState(true);
  const [openADMIN, setOpenADMIN] = useState(true);
  const [openUSER, setOpenUSER] = useState(true);
  const [openCASH, setOpenCASH] = useState(true);
  const [openNML, setOpenNML] = useState(true);
  const [openNmlSuzhou, setOpenNmlSuzhou] = useState(true);
  const [openPRO, setOpenPRO] = useState(true);
  // 🔹 BADGE DE TAREAS NUEVAS
  const [tareasNuevas, setTareasNuevas] = useState([]);

  // BADGE DE NUEVAS NOTAS
  const [notasNuevas, setNotasNuevas] = useState(0);

  // BADGE PETICIONES CONTROL HORARIO (RRHH)
  const { total: peticionesHorarioPendientes } = usePendingTimeTrackingCount({
    poll: !!userPermissions.Permiso_ControlHorario_RRHH,
  });

  // Abre drawer Instructions
  const [openInstrucciones, setOpenInstrucciones] = useState(false);
  const [openCONOCIMIENTO, setOpenCONOCIMIENTO] = useState(true);
  const { i18n, t } = useTranslation();
  const [langAnchor, setLangAnchor] = useState(null);
  /** FAB Matrix minimizado: dashboard solo al hover del icono (sin zona invisible encima). */
  const [matrixFabDashOpen, setMatrixFabDashOpen] = useState(false);
  const matrixFabHideTimerRef = useRef(null);

  const clearMatrixFabHideTimer = useCallback(() => {
    if (matrixFabHideTimerRef.current) {
      clearTimeout(matrixFabHideTimerRef.current);
      matrixFabHideTimerRef.current = null;
    }
  }, []);

  const openMatrixFabDash = useCallback(() => {
    clearMatrixFabHideTimer();
    setMatrixFabDashOpen(true);
  }, [clearMatrixFabHideTimer]);

  const scheduleCloseMatrixFabDash = useCallback(() => {
    clearMatrixFabHideTimer();
    matrixFabHideTimerRef.current = setTimeout(() => {
      setMatrixFabDashOpen(false);
      matrixFabHideTimerRef.current = null;
    }, 180);
  }, [clearMatrixFabHideTimer]);

  useEffect(
    () => () => {
      if (matrixFabHideTimerRef.current) {
        clearTimeout(matrixFabHideTimerRef.current);
      }
    },
    [],
  );

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lng", lng);
    setLangAnchor(null);
  };
  const currentLang =
    LANGUAGE_FLAGS.find((f) => i18n.language?.startsWith(f.code)) ||
    LANGUAGE_FLAGS[0];
  const toggleDASHBOARD = () => setOpenDASHBOARD((v) => !v);
  const toggleCRM = () => setOpenCRM((v) => !v);
  const togglePNL = () => setOpenPNL((v) => !v);
  const toggleRESOURCES = () => setOpenRESOURCES((v) => !v);
  const toggleTRACKING = () => setOpenTRACKING((v) => !v);
  const toggleVENTAS = () => setOpenVENTAS((v) => !v);
  const toggleADMIN = () => setOpenADMIN((v) => !v);
  const toggleUSER = () => setOpenUSER((v) => !v);
  const toggleCASH = () => setOpenCASH((v) => !v);
  const toggleNML = () => setOpenNML((v) => !v);
  const toggleNmlSuzhou = () => setOpenNmlSuzhou((v) => !v);
  const togglePRO = () => setOpenPRO((v) => !v);
  const toggleCONOCIMIENTO = () => setOpenCONOCIMIENTO((v) => !v);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      jwtDecode(token);
    } catch (error) {
      console.error("Error decodificando token:", error);
    }
    const loadTareas = async () => {
      try {
        // 🧠 No hace falta enviar email; el backend usa el token
        const nuevas = await TareasVistasApi.getNuevas();
        setTareasNuevas(nuevas || []);
      } catch (err) {
        console.error("❌ Error cargando tareas nuevas:", err);
      }
    };
    // Primera carga inmediata
    loadTareas();
    // 🔁 Refrescar automáticamente cada 60 s
    const interval = setInterval(loadTareas, 60000);
    // 🔔 Escuchar evento global para limpiar el badge cuando ToDoListGlobal lo emite
    const handleClearBadge = () => {
      setTareasNuevas([]);
    };
    window.addEventListener("tareas-vistas-clear", handleClearBadge);
    return () => {
      clearInterval(interval);
      window.removeEventListener("tareas-vistas-clear", handleClearBadge);
    };
  }, []);

  //BADGE NOTAS NUEVAS
  const loadNotasNuevas = useCallback(async () => {
    if (!userId) return;

    try {
      const data = await getNotasNuevas(userId);
      setNotasNuevas(data.total || 0);
    } catch (err) {
      console.error("❌ Error cargando notas nuevas:", err);
    }
  }, [userId]);

  useEffect(() => {
    if (!userId) return;
    loadNotasNuevas();
  }, [userId, loadNotasNuevas]);

  useEffect(() => {
    if (!userId) return;

    const handleNuevaNota = () => {
      loadNotasNuevas();
    };

    socket.on("criticalpath-nota-creada", handleNuevaNota);

    return () => {
      socket.off("criticalpath-nota-creada", handleNuevaNota);
    };
  }, [userId, loadNotasNuevas]);

  useEffect(() => {
    if (!userId) return;

    const handleNotasLeidas = () => {
      loadNotasNuevas(); // 🔥 recalcula el badge
    };

    window.addEventListener("notas-leidas", handleNotasLeidas);

    return () => {
      window.removeEventListener("notas-leidas", handleNotasLeidas);
    };
  }, [userId, loadNotasNuevas]);

  //BAGDE TAREAS NUEVAS
  const drawer = (
    <div
      ref={drawerContentRef}
      style={{
        width: drawerWidth,
      }}
    >
      {showRail ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
            py: 1,
            px: 0.5,
            position: "sticky",
            top: 0,
            zIndex: 20,
            borderBottom: "1px solid",
            borderColor: "divider",
            bgcolor: alpha(theme.palette.background.paper, 0.92),
          }}
        >
          <Tooltip title="Expandir menú" placement="right">
            <Box
              onClick={toggleSidebar}
              component="img"
              src={Matrix6}
              alt="Matrix"
              sx={{
                width: 36,
                height: 36,
                cursor: "pointer",
                borderRadius: 1.5,
              }}
            />
          </Tooltip>
          <Tooltip title={t("common.language")} placement="right">
            <IconButton
              size="small"
              onClick={(e) => setLangAnchor(e.currentTarget)}
              sx={{
                width: 32,
                height: 22,
                p: 0.25,
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Box
                component="img"
                src={currentLang.img}
                alt={currentLang.alt}
                sx={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "2px",
                  objectFit: "cover",
                }}
              />
            </IconButton>
          </Tooltip>
          <Stack spacing={0.25} alignItems="center">
            <Novedades />
            <Tooltip title="Tema" placement="right">
              <IconButton
                color="inherit"
                size="small"
                onClick={colorMode.toggleColorMode}
                sx={{ borderRadius: 1.5 }}
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon fontSize="small" />
                ) : (
                  <Brightness4Icon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title="Ayuda" placement="right">
              <IconButton
                color="inherit"
                size="small"
                onClick={() => setOpenInstrucciones(true)}
                sx={{ borderRadius: 1.5 }}
              >
                <ContactSupportOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={abreviatura || "Usuario"} placement="right">
              <IconButton
                size="small"
                sx={{
                  border: "2px solid",
                  borderColor: "primary.main",
                  color: "primary.main",
                  fontWeight: 700,
                  width: 32,
                  height: 32,
                  fontSize: "0.68rem",
                  borderRadius: 1.5,
                }}
              >
                {abreviatura || "?"}
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            py: { xs: 1, sm: 1.25 },
            px: { xs: 1, sm: 2 },
            position: "sticky",
            top: 0,
            zIndex: 20,
            mx: 0.75,
            mt: 1,
            mb: 0.75,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            background:
              "linear-gradient(135deg, rgba(0,188,212,0.14) 0%, rgba(103,58,183,0.12) 100%)",
            backdropFilter: "blur(10px)",
            boxShadow:
              theme.palette.mode === "dark"
                ? `0 2px 14px ${alpha("#000", 0.35)}`
                : `0 2px 14px ${alpha("#000", 0.06)}`,
          }}
        >
          <Box
            onClick={() => {
              if (useOverlay) setMobileOpen(false);
              else toggleSidebar();
            }}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 1,
            }}
          >
            <Box
              component="img"
              src={Matrix5}
              alt="Matrix Logo"
              sx={{ width: 130, height: 40 }}
            />
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 1, mb: 1 }}
          >
            {LANGUAGE_FLAGS.map((flag) => (
              <IconButton
                key={flag.code}
                size="small"
                onClick={() => changeLanguage(flag.code)}
                sx={{
                  width: 28,
                  height: 20,
                  p: 0.5,
                  borderRadius: 1,
                  border: "1px solid",
                  borderColor:
                    currentLang.code === flag.code ? "primary.main" : "divider",
                  backgroundColor: alpha(theme.palette.background.paper, 0.9),
                  opacity: currentLang.code === flag.code ? 1 : 0.85,
                  "&:hover": {
                    transform: "scale(1.06)",
                    backgroundColor: theme.palette.action.hover,
                  },
                }}
              >
                <Box
                  component="img"
                  src={flag.img}
                  alt={flag.alt}
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "3px",
                    objectFit: "cover",
                  }}
                />
              </IconButton>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 1,
              mt: 0.5,
            }}
          >
            <Tooltip title="Notifications">
              <Box>
                <Novedades />
              </Box>
            </Tooltip>
            <Tooltip title="Change theme color">
              <IconButton
                color="inherit"
                onClick={colorMode.toggleColorMode}
                size="small"
                sx={{
                  borderRadius: 1.5,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                  },
                }}
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
            </Tooltip>
            {!isMobile ? (
              <Tooltip title="Change Sidebar position">
                <IconButton
                  color="inherit"
                  onClick={toggleAnchor}
                  size="small"
                  sx={{
                    borderRadius: 1.5,
                    "&:hover": {
                      bgcolor: alpha(theme.palette.primary.main, 0.1),
                    },
                  }}
                >
                  {sidebarAnchor === "left" ? (
                    <JoinLeftOutlinedIcon />
                  ) : (
                    <JoinRightOutlinedIcon />
                  )}
                </IconButton>
              </Tooltip>
            ) : null}
            <Tooltip title="Help Center">
              <IconButton
                color="inherit"
                size="small"
                onClick={() => setOpenInstrucciones(true)}
                sx={{
                  borderRadius: 1.5,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                  },
                }}
              >
                <ContactSupportOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="User">
              <IconButton
                size="small"
                sx={{
                  border: "2px solid",
                  borderColor: "primary.main",
                  color: "primary.main",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  width: 34,
                  height: 34,
                  fontSize: "0.75rem",
                  borderRadius: 1.5,
                  "&:hover": {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                  },
                }}
              >
                {abreviatura || "?"}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      )}
      <Menu
        anchorEl={langAnchor}
        open={Boolean(langAnchor)}
        onClose={() => setLangAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {LANGUAGE_FLAGS.map((flag) => (
          <MenuItem
            key={flag.code}
            selected={currentLang.code === flag.code}
            onClick={() => changeLanguage(flag.code)}
          >
            <Box
              component="img"
              src={flag.img}
              alt={flag.alt}
              sx={{ width: 22, height: 14, mr: 1.25, borderRadius: "2px" }}
            />
            {flag.alt}
          </MenuItem>
        ))}
      </Menu>
      <Box sx={showRail ? sidebarRailNavSx : undefined}>
        {/* ===== DASHBOARD ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.dashboard")}
            icon={SpaceDashboardOutlinedIcon}
            iconClassName={classes.iconCRM}
            open={openDASHBOARD}
            onClick={toggleDASHBOARD}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openDASHBOARD} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/mi-dashboard"
                  style={getNavLinkStyle}
                >
                  <DashboardCustomizeOutlinedIcon className={classes.iconCRM} />
                  {!showRail && (
                    <ListItemText
                      primary={t("sidebar.myDashboard")}
                      sx={{ ml: 2 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
              {userPermissions.Permiso_Novedades && (
                <ListItem disablePadding>
                  <ListItemButton component={NavLink} to="/novedadesInsertar">
                    <AssessmentOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.news")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Dashboard && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/dashboard"
                    style={getNavLinkStyle}
                  >
                    <SpaceDashboardOutlinedIcon className={classes.iconCRM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.general")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_DashboardDesigns && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/dashboardDesigns"
                    style={getNavLinkStyle}
                  >
                    <DashboardCustomizeOutlinedIcon
                      className={classes.iconCRM}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.design")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_RankingVenta && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/rankingVentas"
                    style={getNavLinkStyle}
                  >
                    <LeaderboardOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.rankingVentas")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_Organigrama && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/organigrama"
                    style={getNavLinkStyle}
                  >
                    <AccountTreeOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.organigrama")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== CRM ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.crm")}
            icon={PeopleIcon}
            iconClassName={classes.iconCRM}
            open={openCRM}
            onClick={toggleCRM}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openCRM} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_Clients && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/customers"
                    style={getNavLinkStyle}
                  >
                    <PeopleIcon className={classes.iconCRM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.clients")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Reuniones && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/reuniones"
                    style={getNavLinkStyle}
                  >
                    <MicNoneOutlinedIcon className={classes.iconCRM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.meetings")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_KambanClientes && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/kanban"
                    style={getNavLinkStyle}
                  >
                    <ViewKanbanOutlinedIcon className={classes.iconCRM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.kanbanClients")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_KambanProyectos && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/kanbanproyectos"
                    style={getNavLinkStyle}
                  >
                    <AccountTreeOutlinedIcon className={classes.iconCRM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.kanbanProjects")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_ToDoListGlobal && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/tareas"
                    style={getNavLinkStyle}
                  >
                    <Badge
                      badgeContent={
                        userPermissions.isAdmin
                          ? tareasNuevas.length
                          : tareasNuevas.filter(
                              (t) => t.ResponsableId === userId,
                            ).length
                      }
                      invisible={
                        tareasNuevas.length === 0 ||
                        (!userPermissions.isAdmin &&
                          !tareasNuevas.some((t) => t.ResponsableId === userId))
                      }
                      sx={{
                        "& .MuiBadge-badge": {
                          backgroundColor: "#ff0000ff",
                          color: "white",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                          /* boxShadow: "0 0 0 2px white", */
                        },
                      }}
                    >
                      <DvrOutlinedIcon className={classes.iconCRM} />
                    </Badge>
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.toDoListGlobal")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Task && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/calendar"
                    style={getNavLinkStyle}
                  >
                    <CalendarTodayIcon className={classes.iconCRM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.taskCalendar")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>

        {/* ===== AI SEARCH ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.AISearch")}
            icon={AutoAwesomeOutlinedIcon}
            iconClassName={classes.iconAI}
            open={openPNL}
            onClick={togglePNL}
            buttonClassName={classes.cabsidebar2}
          />
          <Collapse in={openPNL} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_Nasdesign && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/aiSearch"
                    style={getNavLinkStyle}
                  >
                    <AutoAwesomeOutlinedIcon className={classes.iconAI} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.nasdesign")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_PresentacionesAI && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/presentacionesSearch"
                    style={getNavLinkStyle}
                  >
                    <AutoAwesomeOutlinedIcon className={classes.iconAI} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.presentacionesAI")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Skills && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/skills"
                    end
                    style={getNavLinkStyle}
                  >
                    <AutoAwesomeOutlinedIcon className={classes.iconAI} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.skills")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_TareasAgentes && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/skills/tareas"
                    style={getNavLinkStyle}
                  >
                    <AutoAwesomeOutlinedIcon className={classes.iconAI} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.skillsTasks", {
                          defaultValue: "Tareas agentes",
                        })}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== DEVELOPMENT ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.development")}
            icon={DrawOutlinedIcon}
            iconClassName={classes.iconPLM}
            open={openPNL}
            onClick={togglePNL}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openPNL} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_Designs && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/producttree"
                    style={getNavLinkStyle}
                  >
                    <DrawOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.designs")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_Samples && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/muestras"
                    style={getNavLinkStyle}
                  >
                    <DryCleaningOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.samples")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Samples && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/muestras1"
                    style={getNavLinkStyle}
                  >
                    <DryCleaningOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.lookbook")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Estimates && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/estimates"
                    style={getNavLinkStyle}
                  >
                    <PriceCheckIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.estimates")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_Articulos && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/articulosA3"
                    style={getNavLinkStyle}
                  >
                    <Inventory2OutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.articulosA3")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_PedidosA3 && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/produccionSummary"
                    style={getNavLinkStyle}
                  >
                    <LibraryBooksOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.produccionSummary")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_PedidosA3 && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/gestionLogisticaPedidos"
                    style={getNavLinkStyle}
                  >
                    <LocalShippingOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.logisticaPedidos")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== RESOURCES ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.resources")}
            icon={ColorLensOutlinedIcon}
            iconClassName={classes.iconPLM}
            open={openRESOURCES}
            onClick={toggleRESOURCES}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openRESOURCES} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_Colores && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/colores-muestras"
                    style={getNavLinkStyle}
                  >
                    <ColorLensOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.coloresMuestras")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Colores && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/colores"
                    style={getNavLinkStyle}
                  >
                    <ColorLensOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.colores")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Materialoteca && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/materialoteca"
                    style={getNavLinkStyle}
                  >
                    <DesignServicesOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.materialoteca")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Ferias && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/ferias"
                    style={getNavLinkStyle}
                  >
                    <EventOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.ferias")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Suppliers && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/proveedores"
                    style={getNavLinkStyle}
                  >
                    <PrecisionManufacturingIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.suppliers")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Suppliers && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/fabricas"
                    style={getNavLinkStyle}
                  >
                    <FactoryOutlined className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.factories")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== TRACKING ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.tracking")}
            icon={LocationOnOutlinedIcon}
            iconClassName={classes.iconPLM}
            open={openTRACKING}
            onClick={toggleTRACKING}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openTRACKING} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_SamplesLocation && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/muestrasUbicacion"
                    style={getNavLinkStyle}
                    onClick={() => setMovimientosNuevos(0)} // ✅ limpiar al entrar
                  >
                    <Badge
                      badgeContent={movimientosNuevos}
                      invisible={movimientosNuevos === 0}
                      sx={{
                        "& .MuiBadge-badge": {
                          backgroundColor: "#ff0000ff",
                          color: "white",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                          minWidth: 22,
                        },
                      }}
                    >
                      <LocationOnOutlinedIcon className={classes.iconPLM} />
                    </Badge>
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.samplesLocation")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_SamplesLocation && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/muestrasMovimientoCamara"
                    style={getNavLinkStyle}
                  >
                    <VideoCameraFrontOutlinedIcon className={classes.iconPLM} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.samplesMovement")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {/* {userPermissions.Permiso_Maletash && (
              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/maletas"
                  style={getNavLinkStyle}
                >
                  <WorkOutlineOutlinedIcon className={classes.iconPLM} />
                  {!showRail && (
                    <ListItemText
                      primary={t("sidebar.maletas")}
                      sx={{ ml: 2 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            )} */}
            </List>
          </Collapse>
        </List>
        {/* ===== MANUFACTURING ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.manufacturing")}
            icon={FactoryOutlined}
            iconClassName={classes.iconMANUFACTURING}
            open={openPRO}
            onClick={togglePRO}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openPRO} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_CriticalPathUnido && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/criticalPath"
                    style={getNavLinkStyle}
                  >
                    <RoundaboutRightOutlinedIcon
                      className={classes.iconMANUFACTURING}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.criticalPathUnitario")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_CriticalPathGlobal && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/criticalPathHorizontal"
                    style={getNavLinkStyle}
                  >
                    <AlignHorizontalLeftOutlinedIcon
                      className={classes.iconMANUFACTURING}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.criticalPathGlobal")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_CriticalPathGlobal && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/criticalPathHorizontal1"
                    style={getNavLinkStyle}
                  >
                    <SportsCricketOutlinedIcon
                      className={classes.iconMANUFACTURING}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.criticalPathGant")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_SeeAllNotes && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/notasResumen"
                    style={getNavLinkStyle}
                  >
                    <Badge
                      badgeContent={notasNuevas}
                      invisible={notasNuevas === 0}
                      sx={{
                        "& .MuiBadge-badge": {
                          backgroundColor: "#ff0000",
                          color: "white",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                        },
                      }}
                    >
                      <ChecklistRtlOutlinedIcon
                        className={classes.iconMANUFACTURING}
                      />
                    </Badge>

                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.criticalPathNotes")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== ADMINISTRATION ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.administration")}
            icon={DvrOutlinedIcon}
            iconClassName={classes.iconADMIN}
            open={openADMIN}
            onClick={toggleADMIN}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openADMIN} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_Brands && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/gestionmarcas"
                    style={getNavLinkStyle}
                  >
                    <PeopleIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.brands")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_CurrencyManager && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/currencyManager"
                    style={getNavLinkStyle}
                  >
                    <PriceCheckIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.currencyManager")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Duties && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/dutties"
                    style={getNavLinkStyle}
                  >
                    <AssuredWorkloadOutlinedIcon
                      className={classes.iconADMIN}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.duties")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Duties && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/ddp-import-tarifas"
                    style={getNavLinkStyle}
                  >
                    <ImportExportOutlinedIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.ddpImportTarifas")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Cbm && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/volumenPrenda"
                    style={getNavLinkStyle}
                  >
                    <LocalShippingOutlinedIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.cbmGarment")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>{" "}
        </List>
        {/* ===== FINANCE ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.finance")}
            icon={AccountBalanceWalletOutlinedIcon}
            iconClassName={classes.iconCASH}
            open={openCASH}
            onClick={toggleCASH}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openCASH} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_InsightsEjecutivos && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/insights"
                    style={getNavLinkStyle}
                  >
                    <InsightsOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.insightsEjecutivos")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_InformesEC && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/informes-ec"
                    style={getNavLinkStyle}
                  >
                    <AssessmentOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.informesEC")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_PyG && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/pygdebug"
                    style={getNavLinkStyle}
                  >
                    <EuroIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText primary={t("sidebar.pyg")} sx={{ ml: 2 }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {/* ANALITICA PYG */}

              {userPermissions.Permiso_PyG && (
                <>
                  <ListItem disablePadding>
                    <ListItemButton
                      component={NavLink}
                      to="/pyg-analitico/fusion"
                      end
                      style={getNavLinkStyle}
                    >
                      <BubbleChartOutlinedIcon className={classes.iconPLM} />
                      {!showRail && (
                        <ListItemText
                          primary={t("sidebar.analiticaPyg")}
                          sx={{ ml: 2 }}
                        />
                      )}
                    </ListItemButton>
                  </ListItem>

                  <ListItem disablePadding>
                    <ListItemButton
                      component={NavLink}
                      to="/pyg-analitico/fusion/por-marca"
                      end
                      style={getNavLinkStyle}
                    >
                      <BubbleChartOutlinedIcon className={classes.iconPLM} />
                      {!showRail && (
                        <ListItemText
                          primary={t("sidebar.analiticaPorMarca")}
                          sx={{ ml: 2 }}
                        />
                      )}
                    </ListItemButton>
                  </ListItem>
                </>
              )}
              {/* ANALITICA PYG */}

              {userPermissions.Permiso_CashFlow && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/cashflow"
                    style={getNavLinkStyle}
                  >
                    <AutoGraphOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.cashFlow")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_Tpv && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/tpv"
                    style={getNavLinkStyle}
                  >
                    <StorefrontOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText primary={t("sidebar.tpv")} sx={{ ml: 2 }} />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_PedidosVenta && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/pedidosVenta"
                    style={getNavLinkStyle}
                  >
                    <WaterfallChartOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.salesOrders")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_VentaTotal && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/ventasTotales"
                    style={getNavLinkStyle}
                  >
                    <AutoModeOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.salesOverview")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_MargenesVenta && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/tablaReducida"
                    style={getNavLinkStyle}
                  >
                    <AccountBalanceWalletOutlinedIcon
                      className={classes.iconCASH}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.commissions")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_Expenses && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/expenses"
                    style={getNavLinkStyle}
                  >
                    <PointOfSaleOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.expensesLegacy")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_ExpensesNew && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/expenses-user/notes"
                    style={getNavLinkStyle}
                  >
                    <PointOfSaleOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.expensesUser")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}

              {userPermissions.Permiso_Nominas && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/nominas"
                    style={getNavLinkStyle}
                  >
                    <PaymentOutlinedIcon className={classes.iconCASH} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.nominas")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== NML FINANZAS ===== */}
        {userPermissions.Permiso_NMLFinanzas && (
          <List className={classes.cabsidebar1}>
            <SidebarSectionHeader
              isMinimized={showRail}
              theme={theme}
              label={t("sidebar.nmlFinance")}
              icon={AccountBalanceWalletOutlinedIcon}
              iconClassName={classes.iconNML}
              open={openNML}
              onClick={toggleNML}
              buttonClassName={classes.cabsidebar}
            />
            <Collapse in={openNML} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/pyg-analitico/nml_spain"
                    end
                    style={getNavLinkStyle}
                  >
                    <BubbleChartOutlinedIcon className={classes.iconNML} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.nmlPyg")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/balance-analitico/nml_spain"
                    end
                    style={getNavLinkStyle}
                  >
                    <AccountBalanceOutlinedIcon className={classes.iconNML} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.nmlBalance")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              </List>
            </Collapse>
          </List>
        )}
        {/* ===== NML SUZHOU ===== */}
        {canAccessNmlSuzhou(userPermissions) && (
          <List className={classes.cabsidebar1}>
            <SidebarSectionHeader
              isMinimized={showRail}
              theme={theme}
              label={t("sidebar.nmlSuzhou")}
              icon={ViewWeekOutlinedIcon}
              iconClassName={classes.iconNML}
              open={openNmlSuzhou}
              onClick={toggleNmlSuzhou}
              buttonClassName={classes.cabsidebar}
            />
            <Collapse in={openNmlSuzhou} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {canAccessNmlBoard(userPermissions, "SUZHOU") && (
                  <ListItem disablePadding>
                    <ListItemButton
                      component={NavLink}
                      to="/nml/suzhou/critical-path"
                      end
                      style={getNavLinkStyle}
                    >
                      <ViewWeekOutlinedIcon className={classes.iconNML} />
                      {!showRail && (
                        <ListItemText
                          primary={t("sidebar.nmlSuzhouCp")}
                          sx={{ ml: 2 }}
                        />
                      )}
                    </ListItemButton>
                  </ListItem>
                )}
                {canAccessNmlBoard(userPermissions, "TURKEY") && (
                  <ListItem disablePadding>
                    <ListItemButton
                      component={NavLink}
                      to="/nml/turkey/critical-path"
                      end
                      style={getNavLinkStyle}
                    >
                      <ViewWeekOutlinedIcon className={classes.iconNML} />
                      {!showRail && (
                        <ListItemText
                          primary={t("sidebar.nmlTurkeyCp")}
                          sx={{ ml: 2 }}
                        />
                      )}
                    </ListItemButton>
                  </ListItem>
                )}
                {canAccessNmlBoard(userPermissions, "GUANGZHOU") && (
                  <ListItem disablePadding>
                    <ListItemButton
                      component={NavLink}
                      to="/nml/guangzhou/critical-path"
                      end
                      style={getNavLinkStyle}
                    >
                      <ViewWeekOutlinedIcon className={classes.iconNML} />
                      {!showRail && (
                        <ListItemText
                          primary={t("sidebar.nmlGuangzhouCp")}
                          sx={{ ml: 2 }}
                        />
                      )}
                    </ListItemButton>
                  </ListItem>
                )}
              </List>
            </Collapse>
          </List>
        )}
        {/* ===== CONOCIMIENTO ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.BaseConocimiento")}
            icon={SchoolOutlinedIcon}
            iconClassName={classes.iconREPORT}
            open={openCONOCIMIENTO}
            onClick={toggleCONOCIMIENTO}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openCONOCIMIENTO} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_conocimiento && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/conocimiento"
                    style={getNavLinkStyle}
                  >
                    <SchoolOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.Conocimiento")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_CrearMensajes && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/crearMensajes"
                    style={getNavLinkStyle}
                  >
                    <CampaignOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.CrearMensajes")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== TOOLS ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.tools")}
            icon={MiscellaneousServicesIcon}
            iconClassName={classes.iconREPORT}
            open={openVENTAS}
            onClick={toggleVENTAS}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openVENTAS} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* {userPermissions.Permiso_Emails && (
              <ListItem disablePadding>
                <ListItemButton
                  component={NavLink}
                  to="/emails"
                  style={getNavLinkStyle}
                >
                  <AttachEmailOutlinedIcon className={classes.iconREPORT} />
                  {!showRail && (
                    <ListItemText
                      primary={t("sidebar.emails")}
                      sx={{ ml: 2 }}
                    />
                  )}
                </ListItemButton>
              </ListItem>
            )} */}
              {userPermissions.Permiso_Emails && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/unibox"
                    style={getNavLinkStyle}
                  >
                    <InboxOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.unibox")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_UniboxStats && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/unibox-stats"
                    style={getNavLinkStyle}
                  >
                    <BarChartOutlinedIcon className={classes.iconREPORT} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.uniboxStats")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Booking && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/booking"
                    style={getNavLinkStyle}
                  >
                    <VideoCameraFrontOutlinedIcon
                      className={classes.iconREPORT}
                    />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.booking")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
            </List>
          </Collapse>
        </List>
        {/* ===== USER ===== */}
        <List className={classes.cabsidebar1}>
          <SidebarSectionHeader
            isMinimized={showRail}
            theme={theme}
            label={t("sidebar.user")}
            icon={ContactMailOutlinedIcon}
            iconClassName={classes.iconADMIN}
            open={openUSER}
            onClick={toggleUSER}
            buttonClassName={classes.cabsidebar}
          />
          <Collapse in={openUSER} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {userPermissions.Permiso_UserVisitCard && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/users"
                    style={getNavLinkStyle}
                  >
                    <ContactMailOutlinedIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.userVisitCard")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_JobDescription && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/jobDescriptionPage"
                    style={getNavLinkStyle}
                  >
                    <BadgeOutlinedIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.jobDescription")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {(userPermissions.Permiso_Fichaje ||
                userPermissions.Permiso_ControlHorario_RRHH) && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/control-horario"
                    style={getNavLinkStyle}
                  >
                    <Badge
                      badgeContent={peticionesHorarioPendientes}
                      max={99}
                      invisible={
                        !userPermissions.Permiso_ControlHorario_RRHH ||
                        peticionesHorarioPendientes === 0
                      }
                      sx={{
                        "& .MuiBadge-badge": {
                          backgroundColor: "#ff0000",
                          color: "white",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          width: 22,
                          height: 22,
                          borderRadius: "50%",
                        },
                      }}
                    >
                      <AccessTimeOutlinedIcon className={classes.iconADMIN} />
                    </Badge>
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.controlHorario")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_SubirDocsUser && (
                <ListItem disablePadding>
                  <ListItemButton
                    component={NavLink}
                    to="/user-documents"
                    style={getNavLinkStyle}
                  >
                    <DescriptionOutlinedIcon className={classes.iconADMIN} />
                    {!showRail && (
                      <ListItemText
                        primary={t("sidebar.DocsUser")}
                        sx={{ ml: 2 }}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              )}
              {userPermissions.Permiso_Users && (
                <>
                  <Tooltip
                    title="Users Permissions"
                    slotProps={{
                      popper: {
                        modifiers: [
                          { name: "offset", options: { offset: [0, -24] } },
                        ],
                      },
                    }}
                  >
                    <Box>
                      <ListItem disablePadding>
                        <ListItemButton
                          component={NavLink}
                          to="/usersPermissions"
                          style={getNavLinkStyle}
                        >
                          <MiscellaneousServicesIcon
                            className={classes.iconCRM}
                          />
                          {!showRail && (
                            <ListItemText
                              primary={t("sidebar.usersPermissions")}
                              sx={{ ml: 2 }}
                            />
                          )}
                        </ListItemButton>
                      </ListItem>
                    </Box>
                  </Tooltip>
                  <Divider />
                </>
              )}
            </List>
          </Collapse>{" "}
        </List>
      </Box>
      <Divider />
      {/* Login / Logout */}
      <ListItem disablePadding sx={showRail ? { px: 0.5 } : undefined}>
        {isLoggedIn ? (
          <Tooltip
            title={showRail ? t("sidebar.logout") : ""}
            placement="right"
          >
            <ListItemButton
              className={classes.logoutButton}
              onClick={handleLogout}
              sx={
                showRail
                  ? { justifyContent: "center", minHeight: 44, borderRadius: 2 }
                  : undefined
              }
            >
              <ExitToAppIcon className={classes.iconLOGOUT} />
              {!showRail && (
                <ListItemText primary={t("sidebar.logout")} sx={{ ml: 2 }} />
              )}
            </ListItemButton>
          </Tooltip>
        ) : (
          <Tooltip title={showRail ? t("sidebar.login") : ""} placement="right">
            <ListItemButton
              className={classes.logoutButton}
              onClick={() => navigate("/login")}
              sx={
                showRail
                  ? { justifyContent: "center", minHeight: 44, borderRadius: 2 }
                  : undefined
              }
            >
              <ExitToAppIcon className={classes.iconCRM} />
              {!showRail && (
                <ListItemText primary={t("sidebar.login")} sx={{ ml: 2 }} />
              )}
            </ListItemButton>
          </Tooltip>
        )}
      </ListItem>
    </div>
  );
  return (
    <>
      {useOverlay && isLoggedIn && !mobileOpen ? (
        <Box
          sx={{
            position: "fixed",
            bottom: 20,
            ...(sidebarAnchor === "left" ? { left: 16 } : { right: 16 }),
            zIndex: theme.zIndex.drawer + 2,
            width: 52,
            height: 52,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "#00bbcd38",
            boxShadow: `0 6px 20px ${alpha(theme.palette.common.black, 0.18)}`,
            // Solo el icono Matrix captura eventos; no hay puente invisible encima
            // que robe clics del listado (p. ej. último presupuesto).
            transition: "transform 0.18s ease, box-shadow 0.18s ease",
            "&:hover": {
              transform: "scale(1.04)",
              bgcolor: "background.paper",
              boxShadow: `0 10px 28px ${alpha(theme.palette.common.black, 0.22)}`,
            },
          }}
          onMouseEnter={openMatrixFabDash}
          onMouseLeave={scheduleCloseMatrixFabDash}
        >
          <Tooltip
            title={t("sidebar.openMenu")}
            placement={sidebarAnchor === "left" ? "right" : "left"}
          >
            <IconButton
              onClick={toggleMobileDrawer}
              aria-label={t("sidebar.openMenu")}
              sx={{
                width: "100%",
                height: "100%",
                p: 0.75,
                borderRadius: 2,
              }}
            >
              <Box
                component="img"
                src={Matrix6}
                alt="Matrix"
                sx={{
                  width: 36,
                  height: 36,
                  display: "block",
                  borderRadius: 1,
                }}
              />
            </IconButton>
          </Tooltip>

          <Tooltip title={t("sidebar.myDashboard")} placement="top">
            <IconButton
              className="matrix-fab-home"
              aria-label={t("sidebar.myDashboard")}
              onMouseEnter={openMatrixFabDash}
              onMouseLeave={scheduleCloseMatrixFabDash}
              onClick={(e) => {
                e.stopPropagation();
                navigate("/mi-dashboard");
                setMobileOpen(false);
                setMatrixFabDashOpen(false);
              }}
              sx={{
                position: "absolute",
                left: 0,
                bottom: "100%",
                mb: 0.75,
                width: 52,
                height: 52,
                borderRadius: 2,
                opacity: matrixFabDashOpen ? 1 : 0,
                transform: matrixFabDashOpen
                  ? "translateY(0) scale(1)"
                  : "translateY(6px) scale(0.9)",
                pointerEvents: matrixFabDashOpen ? "auto" : "none",
                transition:
                  "opacity 0.18s ease, transform 0.18s ease, background-color 0.18s ease",
                color: "primary.main",
                bgcolor: alpha(theme.palette.background.paper, 0.96),
                border: "1px solid",
                borderColor: alpha(theme.palette.primary.main, 0.4),
                boxShadow: `0 6px 16px ${alpha(theme.palette.common.black, 0.16)}`,
                "&:hover": {
                  bgcolor: alpha(theme.palette.primary.main, 0.14),
                },
              }}
            >
              <SpaceDashboardOutlinedIcon sx={{ fontSize: 26 }} />
            </IconButton>
          </Tooltip>
        </Box>
      ) : null}
      {useOverlay ? (
        mobileOpen ? (
          <Drawer
            variant="temporary"
            open
            onClose={() => setMobileOpen(false)}
            anchor={sidebarAnchor}
            ModalProps={{ keepMounted: true }}
            sx={{
              "& .MuiDrawer-paper": {
                width: drawerWidth,
                boxSizing: "border-box",
                overflowX: "hidden",
                backgroundColor: theme.palette.background.paper,
              },
            }}
          >
            {drawer}
          </Drawer>
        ) : null
      ) : (
        <Drawer
          variant="permanent"
          anchor={sidebarAnchor}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              overflowX: "hidden",
              backgroundColor: theme.palette.background.paper,
              backgroundImage:
                theme.palette.mode === "dark"
                  ? `linear-gradient(180deg, ${alpha("#ffffff", 0.03)} 0%, transparent 42%)`
                  : `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, transparent 38%)`,
              borderRight:
                sidebarAnchor === "left"
                  ? `1px solid ${theme.palette.divider}`
                  : "none",
              borderLeft:
                sidebarAnchor === "right"
                  ? `1px solid ${theme.palette.divider}`
                  : "none",
              boxShadow:
                sidebarAnchor === "left"
                  ? theme.palette.mode === "dark"
                    ? "6px 0 28px rgba(0,0,0,0.32)"
                    : "6px 0 22px rgba(0,0,0,0.06)"
                  : theme.palette.mode === "dark"
                    ? "-6px 0 28px rgba(0,0,0,0.32)"
                    : "-6px 0 22px rgba(0,0,0,0.06)",
            },
          }}
        >
          {drawer}
        </Drawer>
      )}
      {/* 👉 Drawer de instrucciones */}
      <DrawerInstrucciones
        open={openInstrucciones}
        onClose={() => setOpenInstrucciones(false)}
      />
    </>
  );
};
export default Sidebar;
